module.exports = __webpack_public_path__ + "media/payment_options/mastercard-fc189350.png";